import React from 'react'

/**
 * Displays the corresponding deduction rule where items and production rules
 * can be dropped.
 */
export function TagEarleyMoveRight() {
    return (<div className='deduction-rule'>
        <div className='rule-name'>MoveRight:</div>
        <div className='middle-rule-part'>
            <div
                className='antecedence'><span className={'unbreakable'}>[γ, dot, ra, i, j, k, l, 0]</span>
            </div>
            <hr/>
            <div
                className='consequence'><span className={'unbreakable'}>[γ, dot + 1, la, i, j, k, l, 0]</span>
            </div>
        </div>
        <div className='side-condition'><span className={'unbreakable'}>γ(dot + 1) is defined</span></div>
    </div>)
}
